module.exports = __webpack_public_path__ + "img/kid-five-blue.b39d8380.svg";